import {
  getUserAppPreference,
  useUserPreferencesStore,
} from '@/store/user-preferences.store'

import type { AppPreferences } from '@scrambl/shared'

import { useSimpleBennyAvailable } from './BennyAvailabilityProvider'

export function useBennyAvailable() {
  const simpleMode = useSimpleBennyAvailable()
  const preferences = useUserPreferencesStore(state => state.preferences)
  const initialized = useUserPreferencesStore(state => state.isInitialized)
  const app = getUserAppPreference(preferences)?.preferences as
    | AppPreferences
    | undefined
  return (
    simpleMode ||
    (initialized &&
      (app?.bennyEnabled === true || app?.bennyCompanionEnabled === true))
  )
}
